import dayjs from "dayjs";
import { createRef } from "react";
import { Badge } from "./Badge";
import { TooltipTrigger } from "@sellar-io/components";
import { TooltipContent } from "@sellar-io/components";
import { Tooltip } from "@sellar-io/components";
import { Icon } from "@sellar-io/components";

const AvailableFromToolTipContent = ({
  availableFromDate,
}: {
  availableFromDate: Date;
}) => {
  return (
    <div className="max-w-[300px] rounded-xl border border-zinc-300 bg-white px-4 py-3">
      {/* Tooltip tail */}
      <div className="absolute top-[-5px] left-1/2 -translate-x-1/2">
        <div className="h-3 w-3 rotate-45 transform border-t border-l border-gray-300 bg-white"></div>
      </div>
      <div className="flex items-center gap-2 bg-white">
        <Icon icon={"INFORMATION_OUTLINE"} className="text-zinc-800" />
        <div>
          <div className="text-sm font-semibold text-zinc-800">
            Pre-order item
          </div>
          <div className="text-xs text-zinc-700">
            Available from {dayjs(availableFromDate).format("DD/MM/YYYY")}
          </div>
        </div>
      </div>
    </div>
  );
};

export const AvailableFromBadge = ({
  availableFrom,
}: {
  availableFrom: Date;
}) => {
  const isPreOrder = dayjs().isBefore(availableFrom, "day");
  const toolTipRef = createRef<HTMLDivElement>();

  if (isPreOrder) {
    return (
      <Tooltip placement="bottom">
        <TooltipTrigger className="w-fit">
          <Badge
            className={
              "pointer-events-auto cursor-pointer items-center gap-1 border border-indigo-500 bg-indigo-50 text-zinc-800 decoration-solid hover:underline"
            }
            ref={toolTipRef}
            icon={"PROGRESS_CLOCK"}
            iconSize={0.8}
          >
            <span className="text-sm font-medium text-zinc-800">
              {dayjs(availableFrom).format("DD/MM/YYYY")}
            </span>
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <AvailableFromToolTipContent availableFromDate={availableFrom} />
        </TooltipContent>
      </Tooltip>
    );
  }

  return null;
};
